<div class="mx-5 d-flex flex-column" style="height: 100%;">

    <button class="btn btn-sm btn-primary my-2 align-self-start" type="button" (click)="toggleDisplayFilters()">
        <span *ngIf="!visibleFilters">
            <paflabel lblCod="Filtres_de_recherche"></paflabel>&nbsp;<i class="fas fa-search"></i>
        </span>
        <span *ngIf="visibleFilters">
            <paflabel lblCod="Masquer_les_filtres"></paflabel>&nbsp;<i class="far fa-caret-square-up"></i>
        </span>
    </button>
    <div class="card bg-light shadow-sm" *ngIf="visibleFilters">
        <div class="card-body">
            <form name="frmListTasks" #ngFrmListuppliers="ngForm">
                <div class="row">
                    <div class="col-4">
                        <switchery-ios label="Mes tâches à traiter" [(ngModel)]="TopMesTaches" size="medium" name="TopMesTaches"></switchery-ios>                        
                    </div>
                    <div class="col-4">
                        <switchery-ios label="Toutes les tâches du même niveau que le mien" [(ngModel)]="TopMemeNiveau" size="medium" name="TopMemeNiveau"></switchery-ios>
                    </div>
                    <div class="col-4">
                        <switchery-ios label="En attente d'informations" [(ngModel)]="TopAttente" size="medium" name="TopAttente"></switchery-ios>
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col text-center">
                        <button class="btn btn-sm btn-primary mx-2" type="commit" (click)="search()"><i
                                class="fas fa-search mr-1"></i>Rechercher</button>
                        <button class="btn btn-sm btn-danger mx-2" type="button" (click)="reinit()"><i
                                class="fas fa-ban mr-1"></i>Réinitialiser</button>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <div class="card mt-3 shadow-sm flex-fill">
        <div class="card-body" ID="tasksListContainer">
            <kendo-grid id="lst-tasks-grid" #grid [data]="gridData" [pageSize]="state.take" [skip]="state.skip"
                [sort]="state.sort" [filter]="state.filter" [sortable]="true" [pageable]="gridPageableSettings"
                [filterable]="'menu'" (dblclick)="dblClickGridEvent()" (cellClick)="selectRow($event)" [height]="600"
                [resizable]="true" (filterChange)="filterChange($event)" (dataStateChange)="dataStateChange($event)">
                <kendo-grid-messages filterIsFalse="Non&nbsp;&nbsp;" filterIsTrue="Oui&nbsp;&nbsp;">
                </kendo-grid-messages>
                <kendo-grid-column field="Id" [width]="20" [filterable]="false" title="">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <history-button [supplierId]="dataItem.Id"></history-button>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="StatutId" [autoSize]="true" title="Statut" class="text-center">
                    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
                        let-filterService="filterService">
                        <div style="width:100%;">
                            <kendo-multiselect class="filter-multi-select form-control" name="filterStatuts"
                                [data]="lstStatuts" textField="traduction" valueField="Id" [valuePrimitive]="true"
                                [value]="state.filter | filterValues"
                                (valueChange)="gridFiltersChange($event, filterService,column)">
                                <ng-template kendoMultiSelectTagTemplate let-dataItem >
                                    <supplier-statut-badge [supplierStatutId]="dataItem.Id" style="width:100%;">
                                    </supplier-statut-badge>
                                </ng-template>
                                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                    <supplier-statut-badge [supplierStatutId]="dataItem.Id" style="width:100%;">
                                    </supplier-statut-badge>
                                </ng-template>
                            </kendo-multiselect>
                        </div>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <supplier-statut-badge [supplierStatutId]="dataItem.StatutId"></supplier-statut-badge>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="SupplierName" [autoSize]="true" title="Nom du fournisseur">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <a class="control-label" [routerLink]="getSupplierLink(dataItem)" [paftooltip]="'Fiche_fournisseur'" target="_blank">
                            {{ dataItem.SupplierName }}
                        </a>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="familiesCellDisplay" title="Savoir-faire" [width]="400">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="familyCell" [innerHTML]="dataItem.familiesCellDisplay"></div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [autoSize]="true" field="IsNucleaire" title="Nucléaire" [width]="100" filter="boolean">
                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                        <div style="text-align: center;"><i [ngClass]="checkNgClass(dataItem.TopNucleaire)"></i></div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [autoSize]="true" field="Demandeur" title="Demandeur" class="text-center">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="text-center" class="cell-vert badge">{{dataItem.Demandeur}}</div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [autoSize]="true" field="AchOpeVal" title="Acheteur Op." class="text-center">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="badge" [ngClass]="cellClass(dataItem.AchOpeColor)">{{dataItem.AchOpeVal}}</div>
                    </ng-template>
                </kendo-grid-column>
                <!-- <kendo-grid-column [autoSize]="true" field="AchFamVal" title="Acheteur Fam." class="text-center">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div [innerHTML]="getAchFamCellDisplay(dataItem)"></div>
                    </ng-template>
                </kendo-grid-column> -->
                <kendo-grid-column [autoSize]="true" field="QualiteVal" title="Ctrl. qualité" class="text-center">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="badge" [ngClass]="cellClass(dataItem.QualiteColor)">{{dataItem.QualiteVal}}</div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [autoSize]="true" field="ComptaVal" title="Comptable" class="text-center">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="badge" [ngClass]="cellClass(dataItem.ComptaColor)">{{dataItem.ComptaVal}}</div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [autoSize]="true" field="MotifOuverture"
                    title="Raison ouverture">
                </kendo-grid-column>
                <kendo-grid-column [autoSize]="true" [format]="{ date: 'short' }" field="DateCreation"
                    title="Date de demande" filter="date">
                </kendo-grid-column>
            </kendo-grid>
        </div>
    </div>
</div>
